import { fromJS } from 'immutable'
import * as constants from './constants'

const defaultState = fromJS({
  selected: null,
  screenPow: 2,
  screenPage: 0
})

export default (state = defaultState, action) => {
  const { type, value } = action
  switch (type) {
    case constants.SELECTED_CAMERA:
      return state.set('selected', value)
    case constants.SET_SCREEN_POW:
      return state.set('screenPow', value)
    case constants.SET_SCREEN_PAGE:
      return state.set('screenPage', value)
    default:
      return state
  }
}
